var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sgp-page sgp-schedule" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("schedule-status")], 1),
    ]),
    _vm._v(" "),
    _vm.project && _vm.project.schedule_link
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.project.schedule_link,
                    height: "500px ",
                    width: "100%",
                  },
                }),
              ]),
            ]),
          ]),
        ])
      : _c("p", [
          _vm._v("\n        There is no schedule template available.\n    "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }